// 選單其他連結
import React from 'react';
import { useSelector } from 'react-redux';
import { urlState } from '@/slices/urlSlice';

// 連結
const links = [
    { title: 'about', name: 'about' },
    { title: 'rules', name: 'rules' },
    { title: 'terms-of-service', name: 'terms' },
    { title: 'privacy-policy', name: 'policy' },
    { title: 'cooperation', name: 'collab', link: 'mailto:business@sounova.com' },
    { title: 'submit', name: 'submit', link: 'mailto:news@sounova.com' },
];

const MenuListContent = ({ t }) => {
    const { memberUrl } = useSelector(urlState);

    return (
        <>
            <ul className="p-[12px] space-y-[20px] hidden ulg:block w-full">
                {links.map((link) => (
                    <li key={link.title} className="w-full">
                        <a
                            href={link.link ? link.link : memberUrl + '/' + link.title}
                            target="_blank"
                            rel="noreferrer noopener"
                            className="between-center gap-x-[10px] group/link"
                        >
                            <span className="w-[6px] h-[6px] flex-shrink-0 rounded-[50%] bg-loa" />
                            <p className="flex-grow">
                                <span className="text-btn1 text-black9 trans group-hover/link:text-bou">
                                    {t(link.title.toUpperCase())}
                                </span>
                                <span className="text-bd3n text-black3 pl-[4px] inline-block trans group-hover/link:text-black9">
                                    {link.name?.toUpperCase()}
                                </span>
                            </p>
                        </a>
                    </li>
                ))}
            </ul>
        </>
    );
};

export default MenuListContent;
